import { render, staticRenderFns } from "./ordstatisticsdatatime_outbound.vue?vue&type=template&id=3c527961&"
import script from "./ordstatisticsdatatime_outbound.vue?vue&type=script&lang=ts&"
export * from "./ordstatisticsdatatime_outbound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordstatisticsdatatime_outbound.vue"
export default component.exports